"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geocodeResultState = exports.geocodeResultCountry = void 0;
const find_1 = __importDefault(require("lodash/find"));
const unwrap_1 = __importDefault(require("../../util/unwrap"));
const geocodeResultCountry = (components) => geocodeResultShortNameForAddressType(components, 'country');
exports.geocodeResultCountry = geocodeResultCountry;
const geocodeResultState = (components) => geocodeResultShortNameForAddressType(components, 'administrative_area_level_1');
exports.geocodeResultState = geocodeResultState;
function geocodeResultShortNameForAddressType(addressComponents, type) {
    var _a;
    return ((_a = (0, unwrap_1.default)((0, find_1.default)(addressComponents, component => component.types.includes(type)), component => component.short_name)) !== null && _a !== void 0 ? _a : undefined);
}
